

















































































































































































































































































































































































import 'reflect-metadata'
import { Component, Vue, Prop } from 'vue-property-decorator'
import DropDownOnColumn from "@/components/planning-pj/datatable/DropDownOnColumn.vue"
import DatePickerOnColumn from "@/components/planning-pj/datatable/DatePickerOnColumn.vue"
import DialogNoteOnColumn from '@/components/planning-pj/dialog/DialogNoteOnColumn.vue'
import { IPlanningPJProvider } from "@/interface/IPlanningPJProvider"
import { TimeOut } from "@/utils/common"
import CheckBoxOnColumn from '@/components/common/data-table/CheckBoxOnColumn.vue'
import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue'
import 'vue2-timepicker/dist/VueTimepicker.css'
@Component({
    components: {
        DropDownOnColumn,
        DatePickerOnColumn,
        DialogNoteOnColumn,
        VueTimepicker
    }
})
export default class DataTableTransferPlanning extends Vue {
	@Prop(Function) public notifcation: any
	@Prop(Function) public isloadding: any
	@Prop() public masterTransferPlanType!: any[]
	@Prop() public masterInspectionTransfer!: any[]
    @Prop() public masterPjDivision!: any[]

    dialogCRNote = false

	dialog = false
    search = "" as string
	selected = [] as any[]
	tableData = [] as any[]

	options = { itemsPerPage: 20 } as any
	footerProps = {  'items-per-page-options': [10, 20, 30, 50] } as any
	masterContractStatus = [] as any[]
	masterReceiveData = [] as any[]
	masterJoinEventData = [] as any[]
	masterpurposeOfBuyData = [] as any[]
	masterInspection1AppointmentStatusData = [] as any[]
	masterTransferStatus = [] as any[]
	masterTransferType = [] as any[]
	masterBankReason = [] as any[]
	masterTransferPlanOperation = [] as any[]
	objectDataChange = [] as any[]
	masterPayStatusType = [] as any[]
	masterPayStatusCusOverPayType = [] as any[]
	masterEmailTransfer = [] as any[]
	masterCRname = [] as any[]
	tempTableData = {
		unitId: 0 as number,
		transferTypeId: 0 as number,
	} as any
	jsonDataSaveTransfer = [] as any[]
	jsonBankLists = [] as any[]
	productId = "" as string
    isColumnQC = false
    masterInspectionTime = this.initialTime()

    filterOnlyCapsText (value: any, search: any, item: any) {
        return value != null &&
            search != null &&
            typeof value === 'string' &&
            value.toString().indexOf(search) !== -1
    }

    tableSelectAll (event: any) {
        if (event.value) this.selected = this.tableData
        if (!event.value) this.selected = []
    }

	headerDataTable () {
        const headerArr =  [
                { text: "ยูนิต",                                              value: "unitCode", width: 120, align: "center fixed-unit-pj", class: "fixed-unit-pj", sortable: false },
                { text: "สถานะการขาย",                                      value: "saleStatus", width: 120 ,align: "center", sortable: false },
                { text: "โมเดล",                                            value: "model", width: 120 , align: "center", sortable: false },
                { text: "พื้นที่ (M2/W2)",                                      value: "area", width: 120 , align: "end", sortable: false },
                { text: "ราคาต่อ ตรม./ตรว.",                                 value: "areaValue", width: 140, align: "end", sortable: false },
                { text: "บ้านเลขที่",                                          value: "address", width: 120 , align: "center", sortable: false },
                { text: "ชื่อลูกค้า",                                           value: "customerName", width: 400 ,sortable: false },
                { text: "VIP",                                              value: "vipStatus", align: "center",width: 130 ,sortable: false },
                { text: "เบอร์โทรศัพท์",                                       value: "mobilePhone", width: 150  ,sortable: false},
                { text: "อีเมล",                                             value: "email", width: 180  ,sortable: false},
                { text: "ราคาตามสัญญา",                                      value: "contractUnitPrice", width: 150, align: "end"  ,sortable: false},
                { text: "ราคาสุทธิ",                                          value: "netPrice", width: 150, align: "end"  ,sortable: false},
                { text: "ประเภทการเข้าตรวจ",                                  value: "transferPlanTypeId", width: 360, align: "center fixed-light-blue-pj", class: "fixed-light-blue-pj" ,sortable: false},
                { text: "วันที่ CR ระบุในจดหมายเชิญตรวจ(กรณีเข้าตรวจหลังโอน)",      value: "inspectionAfterTransferDate", width: 210, align: "center fixed-light-yellow-pj", class: "fixed-light-yellow-pj" ,sortable: false},
                { text: "วันที่ PJ Plan แล้วเสร็จ(กรณีเข้าตรวจหลังโอน)",            value: "planPJAfterTransferDate", width: 210, align: "center fixed-light-blue-pj", class: "fixed-light-blue-pj" ,sortable: false},
                { text: "สถานะการโอน",                                      value: "transferStatus", width: 130, align: "center fixed-light-purple-pj", class: "fixed-light-purple-pj" ,sortable: false},
                { text: "วันที่ CR ระบุในการ์ดเชิญตรวจ",                          value: "letterPlanforCR", width: 210, align: "center fixed-light-yellow-pj", class: "fixed-light-yellow-pj"  ,sortable: false},

                { text: "PJ ผู้รับผิดชอบ",                                     value: "pjCode", width: 360, align: "center fixed-light-blue-pj", class: "fixed-light-blue-pj" ,sortable: false},
                { text: "Plan PJ พร้อมให้เข้าตรวจ#1",                          value: "inspection1PlanPJDate", width: 210, align: "center fixed-light-blue-pj", class: "fixed-light-blue-pj" ,sortable: false},
                { text: "วันเก็บงานเสร็จพร้อมตรวจ#1",                           value: "inspection1FinishPJDate", width: 210, align: "center fixed-light-blue-pj", class: "fixed-light-blue-pj" ,sortable: false},
                { text: "วันที่ CR นัดได้#1",                                    value: "inspection1PlanCRDate", width: 210, align: "center fixed-light-yellow-pj", class: "fixed-light-yellow-pj", sortable: false},
                { text: "เวลาที่ CR นัดได้#1",                                  value: "inspection1PlanCRTime", width: 180, align: "center fixed-light-yellow-pj", class: "fixed-light-yellow-pj", sortable: false},
                { text: "ชื่อบริษัทรับตรวจบ้าน",                                  value: "flagInspectorContractor", width: 210, align: "center fixed-light-yellow-pj", class: "fixed-light-yellow-pj", sortable: false},
                { text: "วันที่ลูกค้าเข้าตรวจจริง#1",                              value: "inspection1CustomerDate", width: 210, align: "center fixed-light-blue-pj", class: "fixed-light-blue-pj", sortable: false},
                { text: "สถานะการรับมอบ#1",                                  value: "inspection1TypeID", width: 210, align: "center fixed-light-blue-pj", class: "fixed-light-blue-pj", sortable: false},

                { text: "Plan PJ พร้อมให้เข้าตรวจ#2",                          value: "inspection2PlanPJDate", width: 210, align: "center fixed-light-blue-pj", class: "fixed-light-blue-pj", sortable: false},
                { text: "วันเก็บงานเสร็จพร้อมตรวจ#2",                           value: "inspection2FinishPJDate", width: 210, align: "center fixed-light-blue-pj", class: "fixed-light-blue-pj", sortable: false},
                { text: "วันที่ CR นัดได้#2",                                    value: "inspection2PlanCRDate", width: 210, align: "center fixed-light-yellow-pj", class: "fixed-light-yellow-pj", sortable: false},
                { text: "เวลาที่ CR นัดได้#2",                                  value: "inspection2PlanCRTime", width: 180, align: "center fixed-light-yellow-pj", class: "fixed-light-yellow-pj", sortable: false},
                { text: "วันที่ลูกค้าเข้าตรวจจริง#2",                              value: "inspection2CustomerDate", width: 210, align: "center fixed-light-blue-pj", class: "fixed-light-blue-pj", sortable: false},
                { text: "สถานะการรับมอบ#2",                                  value: "inspection2TypeID", width: 210, align: "center fixed-light-blue-pj", class: "fixed-light-blue-pj", sortable: false},

                { text: "Plan PJ พร้อมให้เข้าตรวจ#3",                          value: "inspection3PlanPJDate", width: 210, align: "center fixed-light-blue-pj", class: "fixed-light-blue-pj", sortable: false},
                { text: "วันเก็บงานเสร็จพร้อมตรวจ#3",                           value: "inspection3FinishPJDate", width: 210, align: "center fixed-light-blue-pj", class: "fixed-light-blue-pj", sortable: false},
                { text: "วันที่ CR นัดได้#3",                                    value: "inspection3PlanCRDate", width: 210, align: "center fixed-light-yellow-pj", class: "fixed-light-yellow-pj", sortable: false},
                { text: "เวลาที่ CR นัดได้#3",                                  value: "inspection3PlanCRTime", width: 180, align: "center fixed-light-yellow-pj", class: "fixed-light-yellow-pj", sortable: false},
                { text: "วันที่ลูกค้าเข้าตรวจจริง#3",                              value: "inspection3CustomerDate", width: 210, align: "center fixed-light-blue-pj", class: "fixed-light-blue-pj", sortable: false},
                { text: "สถานะการรับมอบ#3",                                  value: "inspection3TypeID", width: 210, align: "center fixed-light-blue-pj", class: "fixed-light-blue-pj", sortable: false},

                { text: "Plan PJ พร้อมให้เข้าตรวจ#4",                          value: "inspection4PlanPJDate", width: 210, align: "center fixed-light-blue-pj", class: "fixed-light-blue-pj", sortable: false},
                { text: "วันเก็บงานเสร็จพร้อมตรวจ#4",                           value: "inspection4FinishPJDate", width: 210, align: "center fixed-light-blue-pj", class: "fixed-light-blue-pj", sortable: false},
                { text: "วันที่ CR นัดได้#4",                                    value: "inspection4PlanCRDate", width: 210, align: "center fixed-light-yellow-pj", class: "fixed-light-yellow-pj", sortable: false},
                { text: "เวลาที่ CR นัดได้#4",                                  value: "inspection4PlanCRTime", width: 180, align: "center fixed-light-yellow-pj", class: "fixed-light-yellow-pj", sortable: false},
                { text: "วันที่ลูกค้าเข้าตรวจจริง#4",                              value: "inspection4CustomerDate", width: 210, align: "center fixed-light-blue-pj", class: "fixed-light-blue-pj", sortable: false},
                { text: "สถานะการรับมอบ#4",                                  value: "inspection4TypeID", width: 210, align: "center fixed-light-blue-pj", class: "fixed-light-blue-pj", sortable: false},

                { text: "CR Note(สำหรับการนัดตรวจ)",                          value: "crNote", width: 400, align: "start fixed-light-yellow-pj", class: "fixed-light-yellow-pj", sortable: false},
                { text: "PJ Note",                                          value: "pjNote", width: 400, align: "start fixed-light-blue-pj", class: "fixed-light-blue-pj", sortable: false},

                { text: "วันที่ CR/PJ นัดได้ล่าสุด",                               value: "finalCRPlanDate", width: 200, align: "center" ,sortable: false},
                { text: "เวลาที่ CR/PJ นัดได้ล่าสุด",                             value: "finalCRPlanTime", width: 200, align: "start" ,sortable: false},
                { text: "ครั้งที่นัดตรวจล่าสุด",                                   value: "finalInspection", width: 200, align: "end" ,sortable: false},
                { text: "วันที่ลูกค้ารับมอบ",                                     value: "customerTransferReal", width: 200, align: "center"  ,sortable: false},
                { text: "CR Plan",                                          value: "csPlanDate", width: 200 , align: "center fixed-light-yellow-pj", class: "fixed-light-yellow-pj", sortable: false},
                { text: "วันที่โอนจริง",                                        value: "transferActDate", width: 200, align: "center" ,sortable: false},
                { text: "สรุปวันโอน(Plan+Actual)",                            value: "finalActualDate", width: 200, align: "center" ,sortable: false},
                { text: "CR ที่รับผิดชอบ",                                      value: "crName", width: 300, align: "start fixed-light-yellow-pj", class: "fixed-light-yellow-pj", sortable: false},
        ]

        if (this.isColumnQC) headerArr.splice(12, 0, { text: "คะแนน QC ครั้งล่าสุด", value: "qcInspection", width: 150 ,align: "center" ,sortable: false});
        if (this.isColumnQC) headerArr.splice(13, 0, { text: "สถานะ QC ครั้งล่าสุด", value: "qcStatus", align: "center", width: 180  ,sortable: false});
        return headerArr
    }

    searchColumn = null
    columnNameLists = this.headerDataTable()

    setSelectedAll () {
        this.selected = this.tableData
    }

    setSelectedByUnitId (unitIds: any) {
        const nUnitIds = unitIds.map((u: any) => (parseInt(u)))
        this.selected = this.tableData.filter(m => nUnitIds.includes(m.unitId))
    }

    initialTime()
	{
		let masterData = [
			{name : '09:00'},{name : '09:15'},{name : '09:30'},{name : '09:45'},
			{name : '10:00'},{name : '10:15'},{name : '10:30'},{name : '10:45'},
			{name : '11:00'},{name : '11:15'},{name : '11:30'},{name : '11:45'},
			{name : '12:00'},{name : '12:15'},{name : '12:30'},{name : '12:45'},
			{name : '13:00'},{name : '13:15'},{name : '13:30'},{name : '13:45'},
			{name : '14:00'},{name : '14:15'},{name : '14:30'},{name : '14:45'},
			{name : '15:00'},{name : '15:15'},{name : '15:30'},{name : '15:45'},
			{name : '16:00'},{name : '16:15'},{name : '16:30'},{name : '16:45'},
			{name : '17:00'},{name : '17:15'},{name : '17:30'},{name : '17:45'},
			{name : '18:00'}
		]
		return masterData;
	}

    isNumberRule(value: any) {
		console.log("value : ",value)

		let isCheck = true
		if (value == null)
		{
			isCheck = true
		}
		else if (value.name != undefined)
		{
			let obj =  this.masterInspectionTime.filter((timeNew) => timeNew.name == value.name)
			if(obj.length == 0)
			{
				isCheck = false
			}
			else{
				isCheck = true
			}
		}
		else
		{
			let obj =  this.masterInspectionTime.filter((timeNew) => timeNew.name == value)
			if(obj.length == 0)
			{
				isCheck = false
			}
			else{
				isCheck = true
			}

			if (value == "")
			{
				isCheck = true
			}
		}

		console.log("isCheck : ",isCheck)

      	return isCheck;
    }

    updateTimeInspection1PlanCRTime (unitId: number, dataTime: any) {

        let timeData = dataTime.target.value

		console.log("timeData : ", timeData)

		this.tableData = this.tableData.map(x => {
			if (x.unitId === unitId) {
				x.inspection1PlanCRTime = timeData
			}

		return x;
		})
	}

    updateTimeInspection2PlanCRTime (unitId: number, dataTime: any) {

        let timeData = dataTime.target.value

		console.log("timeData : ", timeData)

		this.tableData = this.tableData.map(x => {
			if (x.unitId === unitId) {
				x.inspection2PlanCRTime = timeData
			}

		return x;
		})
    }

    updateTimeInspection3PlanCRTime (unitId: number, dataTime: any) {

        let timeData = dataTime.target.value

		console.log("timeData : ", timeData)

		this.tableData = this.tableData.map(x => {
			if (x.unitId === unitId) {
				x.inspection3PlanCRTime = timeData
			}

		return x;
		})
    }

    updateTimeInspection4PlanCRTime (unitId: number, dataTime: any) {

        let timeData = dataTime.target.value

		console.log("timeData : ", timeData)

		this.tableData = this.tableData.map(x => {
			if (x.unitId === unitId) {
				x.inspection4PlanCRTime = timeData
			}

		return x;
		})
    }

    clearSelected () {
        this.selected = []
    }

    toggleTextbox(item: any) {
      if (!item.checked) {
        item.textboxValue = '';
      }
    }

    saveTransfer () {
        if (this.selected.length <= 0) return []
        this.selected = this.tableData.filter(x => this.selected.findIndex(item => item.unitId === x.unitId) > -1)
        return this.selected
    }

    setDataTable (data: any[], isColumnQC: boolean = false) {
        this.isColumnQC = isColumnQC
        this.columnNameLists = this.headerDataTable()
        this.tableData = data.map((x, i) => {
            x.rowId = i
            return x
        })
    }

    refreshDataTable (selected: any[]) {
        let dataTableUpdate = this.tableData = this.tableData.map(x => {
            if (selected.findIndex(item => item.unitId === x.unitId) > -1) {
                x = selected.filter(f => f.unitId === x.unitId)[0]
            }
            return x
        })
        this.tableData = dataTableUpdate.map((x, i) => {
            x.rowId = i
            return x
        })
        this.selected = []
    }

    updateColumnsDataTable (columnName: string, date: string) {
        if (this.selected.length <= 0) {
            this.notifcation("กรุณาเลือกรายการ ยูนิต", "warning")
            return
        }
        this.selected.map(m => {
            m[`${columnName}`] = date
            return m
        })
    }

    changeCRNote (item: IPlanningPJProvider) {
        this.dialogCRNote = true
        const refDialogNoteOnColumn = this.$refs.refDialogNoteOnColumn as DialogNoteOnColumn
        refDialogNoteOnColumn.openDialog(item, "CR Note(สำหรับการนัดตรวจ)", "crNote", true)
    }

    changePJNote (item: IPlanningPJProvider) {
        this.dialogCRNote = true
        const refDialogNoteOnColumn = this.$refs.refDialogNoteOnColumn as DialogNoteOnColumn
        refDialogNoteOnColumn.openDialog(item, "PJ Note", "pjNote", false)
    }

    changeState (key: string, value: string) {
        console.log('key', key, 'value', value)
    }

    changeStateTableItem (tableItem: any) {
        this.tableData.filter(x => x.unitId === tableItem.unitId)[0] = tableItem
    }

    alertInspection1PlanPJDateEmpty (item: IPlanningPJProvider) {
        if (item.inspection1PlanPJDate === "")
            this.notifcation("กรุณากรอก Plan PJ พร้อมให้เข้าตรวจ #1", "warning")
    }

    async changeScrollView (cloumnName: any) {
		if (cloumnName) {
            const element = document.querySelectorAll(`[aria-label^='${cloumnName.text}']`)
            if (element) {
                TimeOut(100).then(() => {
                    element[0].scrollIntoView({ behavior: "smooth", inline: 'center'})
                })
            }
            TimeOut(500).then(() => {
                this.searchColumn = null
            })
		}
	}


}
